var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from 'mobx';
import { Keys } from '@greycat/core';
import { serializable } from 'serializr';
import SectionStore from './SectionStore';
export default class WebSocketStore extends SectionStore {
    constructor(_graph) {
        super('Server Connection', 'fa fa-plug');
        this._graph = _graph;
        this.hostname = 'localhost';
        this.port = 8066;
        this.path = '/';
        this.secured = false;
    }
    configure() {
        try {
            const url = new URL(this.url);
            // tslint:disable-next-line:no-console
            console.log('=> Trying to connect to:', url.toString());
            this._graph.configurePlugin(Keys.g_websocket_client, {
                url: url.hostname,
                port: parseInt(url.port, 10),
                use_wss: url.protocol === 'ws:' ? 0 : 1,
                path: url.pathname,
            });
        }
        catch (err) {
            // TODO handle err on invalid uri
        }
    }
    get url() {
        if (this.secured) {
            return `wss://${this.hostname}:${this.port}${this.path}`;
        }
        else {
            return `ws://${this.hostname}:${this.port}${this.path}`;
        }
    }
}
__decorate([
    observable, serializable,
    __metadata("design:type", String)
], WebSocketStore.prototype, "hostname", void 0);
__decorate([
    observable, serializable,
    __metadata("design:type", Number)
], WebSocketStore.prototype, "port", void 0);
__decorate([
    observable, serializable,
    __metadata("design:type", String)
], WebSocketStore.prototype, "path", void 0);
__decorate([
    observable, serializable,
    __metadata("design:type", Boolean)
], WebSocketStore.prototype, "secured", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WebSocketStore.prototype, "configure", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WebSocketStore.prototype, "url", null);
